(() => {
  class EmailSubscription extends HTMLElement {
    timeoutID = null;

    constructor() {
      super();
      this.observer = new MutationObserver(this.onMutations.bind(this));
      this.observer.observe(this, { childList: true, subtree: true, attributes: false });
      this.inputWrappers = Array.from(this.querySelectorAll('div[data-testid="form-row"]')).filter((inputWrapper) =>
        inputWrapper.querySelector('input'),
      );
    }

    parseInputWrappers() {
      this.observer.disconnect();
      this.inputWrappers.forEach((inputWrapper) => {
        const input = inputWrapper.querySelector('input');
        const label = inputWrapper.querySelector('label');
        const button = inputWrapper.querySelector('button');

        if (button) {
          button.addEventListener('click', () => {
            this.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
        }

        if (!input || !label) return;

        if (input && input.type === 'checkbox') {
          input.closest('div').classList.add('checkbox');
          return;
        }

        const inputs = inputWrapper.querySelectorAll('input');

        if (inputs.length > 1) {
          const inputWrappers = inputWrapper.querySelectorAll('[data-testid="form-component"]');
          inputWrappers.forEach((inputWrapper) => {
            const input = inputWrapper.querySelector('input');
            const label = inputWrapper.querySelector('label');

            this.setInputValues(input);
            this.setEventListeners(input, label, inputWrapper);
          });
        } else {
          this.setInputValues(input);
          this.setEventListeners(input, label, inputWrapper);
        }
      });

      this.classList.add('email-subscription--loaded');
    }

    /**
     * @param {HTMLInputElement} input
     * @param {HTMLLabelElement} label
     * @param {HTMLDivElement} inputWrapper
     */
    setEventListeners(input, label, inputWrapper) {
      inputWrapper.classList.add('input-wrapper');

      if (label.innerText.includes('*')) {
        label.dataset.after = '*';
      }

      const mustBeActive = input.value;
      mustBeActive ? this.activate(inputWrapper) : this.deactivate(inputWrapper, true);

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && input.value) {
          this.checkIfInputValid(input);
        }
      });

      input.addEventListener('focus', () => {
        this.removeError(input);
      });

      input.addEventListener('input', () => {
        this.removeError(input);
        input.value && this.activate(inputWrapper);
      });

      input.addEventListener('blur', () => {
        if (!input.value) {
          this.deactivate(inputWrapper);
          this.checkIfInputValid(input);
        } else {
          this.checkIfInputValid(input);
        }
      });

      input.addEventListener('change', () => {
        if (!input.value) {
          this.deactivate(inputWrapper);
          this.removeError(input);
        } else {
          this.checkIfInputValid(input);
        }
      });
    }

    setInputValues(input) {
      const setValue = (field, value) => {
        input.dispatchEvent(new Event('focus'));
        setTimeout(() => {
          field.value = value;
          field.dispatchEvent(new Event('blur'));
          field.dispatchEvent(new Event('input'));
        }, 0);
      };
      if (input.id.includes('first_name') && this.dataset.customerFirstName) {
        setValue(input, this.dataset.customerFirstName);
      } else if (input.id.includes('last_name') && this.dataset.customerLastName) {
        setValue(input, this.dataset.customerLastName);
      } else if (input.id.includes('email') && this.dataset.customerEmail) {
        setValue(input, this.dataset.customerEmail);
      }
    }

    /**
     * @param {HTMLInputElement} input
     */
    setError(input) {
      input.classList.add('input-wrapper__field--error');
    }

    /**
     * @param {HTMLInputElement} input
     */
    removeError(input) {
      input.classList.remove('input-wrapper__field--error');
    }

    /**
     * @param {HTMLInputElement} input
     */
    checkIfInputValid(input) {
      (input.value && input.matches(':invalid')) || input.getAttribute('aria-invalid') === 'true'
        ? this.setError(input)
        : this.removeError(input);
    }

    /**
     * @param {HTMLDivElement} inputWrapper
     */
    activate(inputWrapper) {
      inputWrapper.classList.add('input-wrapper--filled');
      inputWrapper.classList.remove('input-wrapper--empty');
    }

    /**
     * @param {HTMLDivElement} inputWrapper
     */
    deactivate(inputWrapper, isFirstRender = false) {
      inputWrapper.classList.remove('input-wrapper--filled');
      !isFirstRender && inputWrapper.classList.add('input-wrapper--empty');
    }

    /**
     * @param {MutationRecord[]} mutations
     */
    onMutations(mutations) {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType == Node.ELEMENT_NODE && node instanceof HTMLElement) {
            this.inputWrappers = Array.from(this.querySelectorAll('div[data-testid="form-row"]')).filter(
              (inputWrapper) => inputWrapper.querySelector('input, button'),
            );

            if (this.inputWrappers.length) {
              clearTimeout(this.timeoutID);
              this.timeoutID = setTimeout(this.parseInputWrappers.bind(this), 200);
            }
          }
        });
      });
    }
  }

  if (!window.customElements.get('email-subscription')) {
    window.customElements.define('email-subscription', EmailSubscription);
  }
})();
